module.exports = __webpack_public_path__ + "static/media/cup-jour1.564b0395.svg";